// utilities.js
export function JsItemName(ItemBrand, ItemStrength, ItemName) {

    const item_brand = ItemBrand != null ? ItemBrand : "";
    const strength = ItemStrength != null ? ItemStrength : "";

    const valid_name = item_brand != "" ? item_brand+" ("+ItemName+") "+strength : (strength!= "" ? ItemName+" ("+strength+")" : ItemName);
    
    return valid_name;

  }
  
//   export function anotherFunction(data) {
//     // Your function logic here
//     // ...
//   }